import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import Server from '../../functions/servername';
import $ from "jquery";

class Filter extends React.Component {

  state = {
    allexecutive: [],
    selectedExecutive: '',
    data: []
  }

  componentDidMount() {
    this.getExecutive();
    this.setValue();
  }

  setValue() {
    if (this.props.type == 'set') {
      this.setState({ selectedExecutive: this.props.executive  })
    }
  }

  dataClear() {
    this.setState({
      selectedExecutive: ''
    });
  }

  getExecutive() {
    let context = this;
    $.ajax({
      type: 'POST',
      url: Server() + 'executive/allexecutives.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          context.setExecutive(data);
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
    context.setState({
      selectedExecutive: this.props.selectExecutive
    })
  }

  setExecutive(data) {
    let items = [];
    data.map((y) => {
      items.push({key: y.id+'->'+y.name, text: y.id+'->'+y.name, value: y.id});
    });
    this.setState({
      allexecutive: items,
      data: data
    });
  }

  executive = (f, { value }) => {
    this.props.update('executive', value, this.state.data);
    this.setState({ selectedExecutive: value });
  }

  render() {
    return (
      <div>
        <Dropdown placeholder='Executives'
         fluid search selection onChange={this.executive} style={{fontSize: 11}}
         options={this.state.allexecutive} value={this.state.selectedExecutive} />
      </div>
    );
  }
}

export default Filter;
